import { useCallback, useEffect, useState } from "react";
import { Loader2, Ticket, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { api, formatApiError } from "@/lib/api";

export const PromoCodeBox = ({ interval, promo, onChange }) => {
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const check = useCallback(async (c, iv) => {
    setBusy(true);
    setErr("");
    try {
      const { data } = await api.post("/promo/validate", { code: c, interval: iv });
      onChange(data);
    } catch (e) {
      onChange(null);
      setErr(formatApiError(e));
    } finally {
      setBusy(false);
    }
  }, [onChange]);

  useEffect(() => {
    if (promo && promo.interval !== interval) check(promo.code, interval);
    else if (!promo && err && code.trim()) check(code.trim(), interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [interval]);

  if (!open) {
    return (
      <button onClick={() => setOpen(true)} className="text-xs text-slate-400 hover:text-amber-300 transition-colors inline-flex items-center gap-1.5" data-testid="promo-open-btn">
        <Ticket className="w-3.5 h-3.5" /> Have a promo code?
      </button>
    );
  }
  const clear = () => { onChange(null); setCode(""); setErr(""); };
  return (
    <div className="space-y-1.5 animate-in fade-in duration-200" data-testid="promo-box">
      <form onSubmit={(e) => { e.preventDefault(); if (code.trim()) check(code.trim(), interval); }} className="flex gap-2">
        <Input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="PROMO CODE" disabled={!!promo}
          className="h-9 font-code text-xs tracking-widest bg-inset border-line" data-testid="promo-code-input" />
        {promo ? (
          <button type="button" onClick={clear} className="h-9 px-3 rounded-full border border-line text-slate-300 hover:text-rose-300" data-testid="promo-remove-btn"><X className="w-4 h-4" /></button>
        ) : (
          <button type="submit" disabled={busy} className="h-9 px-4 rounded-full border border-amber-500/40 text-xs text-amber-200 hover:bg-amber-500/10 transition-colors" data-testid="promo-apply-btn">
            {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : "Apply"}
          </button>
        )}
      </form>
      {err && <p className="text-xs text-rose-400" data-testid="promo-error">{err}</p>}
    </div>
  );
};
